import * as React from 'react';

import { WoltInboundLoadItem } from 'common/api-types/warehouse';

export const useAutomaticInboundLoadItemSelection = (
  inboundLoadItems: WoltInboundLoadItem[] | undefined,
  searchQuery: string,
  onItemSelection: (item: WoltInboundLoadItem) => void,
  isDisabled?: boolean,
) => {
  React.useEffect(() => {
    const isExactMatch =
      inboundLoadItems?.length === 1 && inboundLoadItems[0]?.gtin === searchQuery;

    if (!isDisabled && isExactMatch) {
      onItemSelection(inboundLoadItems[0]);
    }
  }, [searchQuery, inboundLoadItems, onItemSelection, isDisabled]);
};
